import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Background from '../../../static/images/millas-plus/hero.jpg'
import Tarjetas from '../../../static/images/millas-plus/black.png'
import Logo from '../../../static/images/millas-plus/logo.png'


const Container = styled.div`
  position: relative;
  text-align: center;
  margin: 0 auto;
  background-position-x: -352px;
  background-repeat: no-repeat;
  background-size: cover;

  h1 {
    font-size: 2em;
    margin: 0 0 0.3em;
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    color: ${props => props.theme.colors.grisOscuro};
    margin: 0 0 0.5em;
  }

  p {
    color: black;
    margin-bottom: 0 0 1.5em;
  }

  ${breakpoint('tablet')`
     background-size: auto;
`}  

  ${breakpoint('desktop')`
    background-position-x: 0;
    background-size: cover;
    h1{
      font-size: 3em;
    }

    h2{
      font-size: 2em;
    }

    a {
      font-size: 1.3em;
    }
  `}    background-size: auto;
`

const Wrapper = styled.div`
  padding: 3em 2em;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    display: flex;
    text-align: left;
    justify-content: center;
  `}
`

const DivContent = styled.div `
    width: 100%;
    background: white;
    border-radius: 15px;
    padding: 50px 0px;
    position: relative;
    top: 360px;
    margin-bottom: 159px;
    box-shadow: 4px 3px 7px 2px #797979;

    & h2 {
        color:${props => props.theme.colors.rojoBac};
        font-weight:600;
        font-size: 30px;
    }

    & p {
        font-size: 27px;
    }

    & img{
        width: 400px;
    }

    ${breakpoint('tablet')`
        padding: 55px 40px;
        display: flex;
        text-align: left;
        justify-content: center;

        & > div {
        max-width: 500px;
        box-sizing: border-box;
        }

        & > div:first-of-type {
            padding-right: 20px;
        }

        & img{
            width: 350px;
            margin-left: -7px;
        }

        & p {
            font-size: 21px;
        }
    `}
`

const ButtonForm = styled.a `
    padding: 26px;
    font-size: 23px;
    width: 75%;
    background: ${props => props.theme.colors.amexBlue};
    text-align: center;
    margin: 0 auto;
    display: block;
    color: white;
    text-decoration: none;
    font-weight: 600;

    ${breakpoint('tablet')`
        width: auto;
        padding: 15px;  
        font-size: 18px;
    `}
`


const DivButtons = styled.div `
    padding: 20px;
    ${breakpoint('tablet')`
        width:40%;
    `}
   
`
const DivText = styled.div `
    padding: 50px;   

    & img {
        width: 150px;
        margin-bottom: 15px;
    }

    ${breakpoint('tablet')`
        width:60%;
        padding: 0px;   
    `}
   
`

const ImgMovil = styled.img `
    margin-top: -170px;
    margin-bottom: -30px;

    ${breakpoint('tablet')`
        display:none;
    `}
`

const ImgDesktop = styled.img `
    display:none;
    ${breakpoint('tablet')`
        display:block;  
    `}
`

const DivButtons1 = styled.div `
    padding: 20px;
    ${breakpoint('tablet')`
        display:none;
    `}
   
`

const ContentButtons = styled.div `
    margin-top: -25px;
    ${breakpoint('tablet')`
        margin-top: 15px;
    `}  
`

const Header = ({ formUrl, multicanalidad, pais }) => (
  <Container style={{ backgroundImage: `url(${Background})`}}>
    <Wrapper>
        <DivContent>
            <DivButtons1>
                    <ImgMovil alt="Combo BAC" src={Tarjetas}></ImgMovil>
            </DivButtons1>
            <DivText>
                <img src={Logo} alt=""></img>
                <h2>Comprá con tu tarjeta Millas Plus en estos comercios y obtené millas adicionales</h2>
                <p>Al pagar con tu tarjeta Millas Plus BAC Credomatic
en los comercios afiliados al programa GO Millas,
acumulás millas adicionales que luego podés
redimir por boletos aéreos y paquetes turísticos en
viajesbaccredomatic.com</p>
            </DivText>  
            <DivButtons>
                <ImgDesktop alt="Combo BAC" src={Tarjetas}></ImgDesktop>
                <ContentButtons><ButtonForm href="https://www.baccredomatic.com/es-cr/tarjetas/credito/solicitud/millasplus">Llená la solicitud</ButtonForm></ContentButtons>
            </DivButtons>
        </DivContent>
    </Wrapper>
  </Container>
);

export default Header